import screen1S5A1 from "./handheld_s5a1_screen1.svg";

export const handHeldsScreensTopicFive = {
	screen1S5A1,
};
